// extracted by mini-css-extract-plugin
export var wordContainer = "_qa-0";